import { render, staticRenderFns } from "./HighchartsCallHistogram.vue?vue&type=template&id=0e23101c&scoped=true"
import script from "./HighchartsCallHistogram.vue?vue&type=script&lang=js"
export * from "./HighchartsCallHistogram.vue?vue&type=script&lang=js"
import style0 from "./HighchartsCallHistogram.vue?vue&type=style&index=0&id=0e23101c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e23101c",
  null
  
)

export default component.exports